import {
  onMounted, toRefs, reactive, computed
} from 'vue';
import EventBus from '../../scripts/lib/EventBus.js';
import {previewDifferentColor, releasePreviewDifferentColor, trackColorChange} from "../../scripts/colorHelper.js";
import { mediaQuery } from '../../scripts/lib/mediaQuery.js';

const templateElement = document.getElementById('color-list-template');

export default {
  template: templateElement ? templateElement.innerHTML : '',

  props: {
    colors: {
      type: Array,
      required: true,
    },
    produktId: {
      type: Number,
      required: false,
    },
  },

  setup(props) {
    const colorGroups = computed(() => {
      return props.colors;
    });

    const state = reactive({
      colorTracking: null,
      checkIfTouchDevice: mediaQuery.checkIfTouchDevice(),
    });

    function selectColor(artikelNr) {
      releasePreviewDifferentColor();
      EventBus.emit('ents:vue:color:changed', artikelNr);
      trackColorChange(this.colorTracking[artikelNr]);
    }

    onMounted(() => {
      state.colorTracking = document.querySelector('.ents-colors__tracking').dataset.entsColorsTrackingJsonContent;
    });

    return {
      ...toRefs(state),
      colorGroups,
      previewDifferentColor,
      releasePreviewDifferentColor,
      selectColor,
    };
  },
};
